const LOAD_ASSESSMENT           = 'LOAD_ASSESSMENT'
const LOAD_ASSESSMENT_SUCCESS   = 'LOAD_ASSESSMENT_SUCCESS'
const LOAD_ASSESSMENT_FAILED    = 'LOAD_ASSESSMENT_FAILED'
const UNMOUNT_ASSESSMENT        = 'UNMOUNT_ASSESSMENT'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const assessmentReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_ASSESSMENT:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_ASSESSMENT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_ASSESSMENT_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_ASSESSMENT:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default assessmentReducer;